import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import Login from '../../modals/components/Login/Login';

export default function LoginPage() {
  const { t } = useTranslation();
  return <PageTemplate title={t('login')} content={<Login />} />;
}
